/**
 * Radio group component
 * 
 */

import React, { PureComponent } from 'react';

// Functions

import Helpers from '../../../utils/functions/helpers';

export default class Radio extends PureComponent {

	static displayName = 'radio';

	constructor(props) {

		super(props);

    	this.state = {

    		value: props.checked,
    		data: { label: props.label, name: props.name, id: props.id + '-' + props.name, type: 'radio', required: props.required, value: props.checked }
    	};

    	this.components = {};
    	this.props.update(this.state.data);
    	this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {

		const target = event.target;
		const radios = target.closest('.radio');
		const checked = radios.querySelectorAll('input[type="radio"]:checked');
		const group = target.closest('.form-group');
		const value = target.value;

		let temp = this.state.data;

		temp.value = value;

		this.setState({ value: value, data: temp });
		this.props.update(this.state.data);
		
		Helpers.removeClass(radios.getElementsByTagName('label'), 'checked');
		Helpers.addClass(checked, 'checked', true);

		Helpers.removeClass(radios.getElementsByTagName('input'), 'is-invalid');
		group.classList.remove('invalid');
	}

	clear() {
		
		let temp = this.state.data;

		temp.value = '';
		
		this.setState({ value: '', data: temp });
	}

	render() {

		const { children } = this.props;

		const id = this.state.data.id;
		const name = this.state.data.name;

		const options = Helpers.recursiveCloneChildren(this, children, { type: this.state.data.type, name: name, id: id, checked: this.state.value, update: this.handleChange, }, ['option']);
			
		return (

			<div className="form-group" id={id}>
				<div className="radio radio-btn">
					{options}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/forms/fields/radio.js